import { FC } from 'react';
import './Card.scss';

interface ICardProps {
  className?: string;
  testId?: string;
  children: React.ReactNode;
}

const Card: FC<ICardProps> = ({ children, className = '', testId }) => {
  return (
    <div data-testid={testId} className={`Card ${className}`}>
      <div className="Card__inner">{children}</div>
    </div>
  );
};

export default Card;
